<template>
  <svg width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M64 118C92.7188 118 116 113.523 116 108C116 102.477 92.7188 98 64 98C35.2812 98 12 102.477 12 108C12 113.523 35.2812 118 64 118Z" fill="#DCDBE1"/>
    <path d="M53.415 21.5H21.415C18.5944 21.5106 15.8932 22.6394 13.9038 24.639C11.9144 26.6385 10.7993 29.3454 10.803 32.166L10.75 96.164C10.759 98.99 11.8856 101.698 13.8839 103.696C15.8822 105.694 18.59 106.821 21.416 106.83H106.75C109.576 106.821 112.284 105.694 114.282 103.696C116.28 101.698 117.407 98.99 117.416 96.164V42.832C117.407 40.006 116.28 37.2982 114.282 35.2999C112.284 33.3016 109.576 32.175 106.75 32.166H64.081L53.415 21.5Z" fill="#807B91"/>
  </svg>
</template>

<script>
export default {
	name: 'b-folder-with-shadow',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
  path.a {
    fill: none;
  }
</style>

<docs>
    IconFolderWithShadow

    ```js
    <b-folder-with-shadow />
    ```
</docs>
